<div *ngIf="usuario.typ_name == 'PACIENTE'" class="col-md-12 p-0"> <!--  *ngIf="tipo_usuario_name=='PACIENTE'" -->
  <br>
  <div class="minititulo">
    Mi perfil
  </div>

  <div class="titulo">
    <div class="row">
      <div class="col-md-6">

        Mis antecedentes
      </div>

    </div>
  </div>
  <br>
</div>


<div class="acordeon-antecedentes" style="font-family: 'Mulish', sans-serif; min-height: 40px !important;">
  <div class="col" style=" min-height: 40px !important;" *ngIf="isLoading">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label"></p>
    </div>
  </div>
  <ng-container *ngIf="!isLoading">
    <!-- === Alergias === -->
    <section class="acc-item" [class.open]="open.alergias">
      <header class="acc-header" (click)="toggle('alergias')">
        <div class="acc-left">
          <i class="fi fi-rr-flower" style="display: flex;
      font-size: larger;"></i>
          <span>Alergias</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.alergias">expand_more</mat-icon>
        </div>
      </header>

      <div class="acc-body">

        <!-- Botón Agregar -->
        <div class="text-center mb-2" *ngIf="!agregandoAlergia && (mis_antecedentes?.allergic?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarAlergia()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <!-- Listado (oculto si estoy agregando) -->
        <ng-container *ngIf="!agregandoAlergia">
          <div *ngFor="let item of (mis_antecedentes?.allergic || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;"> {{ item.ben_fil_all_allergic | titlecase}}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'alergias')" style="display: flex; align-items: center; gap: 5px; cursor: pointer;
               width: fit-content; justify-content: flex-end;">

                <i class="fi fi-rr-trash"></i>
              </div>

            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-calendar"></i>
                <span>
                  {{ item.ben_fil_all_start_date | date:'dd/MM/yyyy' }}
                </span>
                <span style="background-color: #316AD8; padding:2px 5px; color: white; border-radius: 5px;">
                  {{ item.ben_fil_all_sev_id }}
                </span>
              </div>
              <div>Reacción: {{ item.ben_fil_all_reaction }}</div>
            </div>

          </div>

        </ng-container>

        <!-- Formulario (visible si agregando o si no hay registros) -->
        <div *ngIf="agregandoAlergia || (mis_antecedentes?.allergic?.length || 0) === 0">
          <form [formGroup]="alergiaForm" (ngSubmit)="agregarAlergia()">
  <div class="form-group">

    <div class="field-top mb-2">
      <label class="field-top__label">Nombre de la alergia</label>
      <input type="text" class="form-control" formControlName="alergia" placeholder="">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Fecha de inicio</label>
      <input type="date" class="form-control" formControlName="fecha_inicio">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Severidad</label>
      <select formControlName="severidad" class="form-control">
        <option value="" selected>Selecciona</option>
        <option [value]="zona.sev_id" *ngFor="let zona of severidades">{{ zona.sev_name }}</option>
      </select>
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Reacción</label>
      <input type="text" class="form-control" formControlName="reaccion_producida" placeholder="">
    </div>

    <div class="text-right">
      <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarAlergia()">Cancelar</button>
      <button type="submit" class="btn btn-guardar px-4" [disabled]="alergiaForm.invalid">Guardar cambios</button>
    </div>

  </div>
</form>

        </div>

        <button type="button" class="acc-collapse" (click)="toggle('alergias')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </section>

    <!-- === Antecedentes familiares === -->
    <section class="acc-item" [class.open]="open.familiares">
      <header class="acc-header" (click)="toggle('familiares')">
        <div class="acc-left">
          <i class="fi fi-rr-chart-tree" style="display: flex;
      font-size: larger;"></i> <span>Antecedentes familiares</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.familiares">expand_more</mat-icon>
        </div>
      </header>

      <div class="acc-body">

        <!-- Botón Agregar -->
        <div class="text-center mb-2" *ngIf="!agregandoFamiliar && (mis_antecedentes?.familiar?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarFamiliar()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <!-- Listado (oculto si estoy agregando) -->
        <ng-container *ngIf="!agregandoFamiliar">
          <div *ngFor="let item of (mis_antecedentes?.familiar || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;">{{ item.ben_fil_fam_pathology | titlecase}}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'familiares')"
                style="display: flex; align-items: center; gap: 5px; cursor: pointer;width: fit-content; justify-content: flex-end;">
                <i class="fi fi-rr-trash"></i>
              </div>
            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-chart-tree"></i>
                <span>
                  Relación: {{ item.ben_fil_fam_ben_rel_id |titlecase}}
                </span>
              </div>
              <div>{{ item.ben_fil_fam_comments }}</div>
            </div>

          </div>

        </ng-container>

        <!-- Formulario (visible si agregando o si no hay registros) -->
        <div *ngIf="agregandoFamiliar || (mis_antecedentes?.familiar?.length || 0) === 0">
          <form [formGroup]="familiaForm" (ngSubmit)="crearAntecedenteFamiliar()">
  <div class="form-group">

    <div class="field-top mb-2">
      <label class="field-top__label">Nombre de la patología</label>
      <input type="text" class="form-control" formControlName="patologia" placeholder="">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Relación familiar</label>
      <select formControlName="relacion_familiar" class="form-control">
        <option value="" selected>Selecciona</option>
        <option [value]="zona.ben_rel_id" *ngFor="let zona of relacion">{{ zona.ben_rel_name }}</option>
      </select>
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Comentario (opcional)</label>
      <input type="text" class="form-control" formControlName="comentario" placeholder="">
    </div>

    <div class="text-right">
      <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarFamiliar()">Cancelar</button>
      <button type="submit" class="btn btn-guardar px-4" [disabled]="familiaForm.invalid">Guardar cambios</button>
    </div>

  </div>
</form>

        </div>

        <button type="button" class="acc-collapse" (click)="toggle('familiares')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </section>
    <section class="acc-item" [class.open]="open.hospitalizaciones">
      <header class="acc-header" (click)="toggle('hospitalizaciones')">
        <div class="acc-left">
          <i class="fi fi-rr-doctor" style="display: flex;
      font-size: larger;"></i> <span>Hospitalizaciones</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.hospitalizaciones">expand_more</mat-icon>
        </div>
      </header>

      <div class="acc-body">
        <div class="text-center mb-2"
          *ngIf="!agregandoHospitalizacion && (mis_antecedentes?.hospitalizations?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarHospitalizacion()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <ng-container *ngIf="!agregandoHospitalizacion">
          <div *ngFor="let item of (mis_antecedentes?.hospitalizations || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;"> {{ item.ben_file_hos_reason }}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'hospitalizaciones')"
                style="display: flex; align-items: center; gap: 5px; cursor: pointer-content; justify-content: flex-end;">
                <i class="fi fi-rr-trash"></i>
              </div>
            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-calendar"></i>
                <span>
                  {{ item.ben_file_hos_start_date | date:'dd/MM/yyyy' }}
                </span>
                -
                <i class="fi fi-rr-calendar"></i>
                <span>
                  {{ item.ben_file_hos_end_date | date:'dd/MM/yyyy' }}
                </span>
              </div>
              <div>{{ item.ben_file_hos_comments }}</div>
            </div>

          </div>

        </ng-container>

        <div *ngIf="agregandoHospitalizacion || (mis_antecedentes?.hospitalizations?.length || 0) === 0">
          <form [formGroup]="hospitalizacionForm" (ngSubmit)="crearHospitalizacion()">
  <div class="form-group">

    <div class="field-top mb-2">
      <label class="field-top__label">Motivo</label>
      <input type="text" class="form-control" formControlName="motivo" placeholder="">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Fecha de inicio</label>
      <input type="date" class="form-control" formControlName="fecha_inicio">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Fecha de término</label>
      <input type="date" class="form-control" formControlName="fecha_fin">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Comentario (opcional)</label>
      <textarea class="form-control" rows="4" formControlName="comentario" placeholder=""></textarea>
    </div>

    <div class="text-right">
      <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarHospitalizacion()">Cancelar</button>
      <button type="submit" class="btn btn-guardar px-4" [disabled]="hospitalizacionForm.invalid">Guardar cambios</button>
    </div>

  </div>
</form>

        </div>
        <button type="button" class="acc-collapse" (click)="toggle('hospitalizaciones')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>

    </section>

    <section class="acc-item" [class.open]="open.patologias">
      <header class="acc-header" (click)="toggle('patologias')">
        <div class="acc-left">
          <i class="fi fi-rr-mask-face" style="display: flex;
      font-size: larger;"></i> <span>Patologias</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.patologias">expand_more</mat-icon>
        </div>
      </header>
      <div class="acc-body">
        <div class="text-center mb-2" *ngIf="!agregandoPatologia && (mis_antecedentes?.pathology?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarPatologia()">
            <span class="plus">+</span> Agregar
          </button>
        </div>
        <ng-container *ngIf="!agregandoPatologia">
          <div *ngFor="let item of (mis_antecedentes?.pathology || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;"> {{ item.ben_fil_pat_name }}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'patologias')"
                style="display: flex; align-items: center; gap: 5px; cursor: pointer-content; justify-content: flex-end;">
                <i class="fi fi-rr-trash"></i>
              </div>
            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-calendar"></i>
                <span>
                  {{ item.ben_fil_pat_diagnosis_date | date:'dd/MM/yyyy' }}
                </span>
              </div>
              <div>{{ item.ben_fil_pat_ben_comments }}</div>
            </div>

          </div>
        </ng-container>
        <div *ngIf="agregandoPatologia || (mis_antecedentes?.pathology?.length || 0) === 0">
          <form [formGroup]="patologiasForm" (ngSubmit)="crearPatologia()">
  <div class="form-group">

    <div class="field-top mb-2">
      <label class="field-top__label">Nombre</label>
      <input type="text" class="form-control" formControlName="nombre" placeholder="">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Fecha de inicio</label>
      <input type="date" class="form-control" formControlName="fecha_inicio">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Comentario (opcional)</label>
      <textarea class="form-control" rows="4" formControlName="comentario" placeholder=""></textarea>
    </div>

    <div class="text-right">
      <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarPatologia()">Cancelar</button>
      <button type="submit" class="btn btn-guardar px-4" [disabled]="patologiasForm.invalid">Guardar cambios</button>
    </div>

  </div>
</form>

        </div>
        <button type="button" class="acc-collapse" (click)="toggle('patologias')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </section>

    <section class="acc-item" [class.open]="open.medicamentos">
      <header class="acc-header" (click)="toggle('medicamentos')">
        <div class="acc-left">
          <i class="fi fi-rr-medicine" style="display: flex;
      font-size: larger;"></i> <span>Medicamentos</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.medicamentos">expand_more</mat-icon>
        </div>
      </header>
      <div class="acc-body">
        <div class="text-center mb-2" *ngIf="!agregandoMedicamento && (mis_antecedentes?.medicine?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarMedicamento()">
            <span class="plus">+</span> Agregar
          </button>
        </div>
        <ng-container *ngIf="!agregandoMedicamento">
          <div *ngFor="let item of (mis_antecedentes?.medicine || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;"> {{ item.ben_fil_med_name | titlecase}}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'medicamentos')"
                style="display: flex; align-items: center; gap: 5px; cursor: pointer-content; justify-content: flex-end;">
                <i class="fi fi-rr-trash"></i>
              </div>
            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-calendar"></i>
                <span>
                  {{ item.ben_fil_med_start_date | date:'dd/MM/yyyy' }}
                </span>
                -
                <i class="fi fi-rr-clock-up-arrow"></i>
                <span>
                  {{ item.ben_fil_med_duration }}
                </span>
              </div>
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-medicine"></i>
                <span>
                  {{ item.ben_fil_med_frecuency }}
                </span>
                -
                <i class="fi fi-rr-medicine"></i>
                <span>
                  {{ item.ben_fil_med_dosis }}
                </span>
              </div>
              <div>{{ item.ben_fil_med_comments }}</div>
            </div>

          </div>
        </ng-container>
        <div *ngIf="agregandoMedicamento || (mis_antecedentes?.medicine?.length || 0) === 0">
          <form [formGroup]="medicamentosForm" (ngSubmit)="crearMedicamento()">
            <div class="form-group">

              <!-- Medicamento -->
              <div class="field-top mb-2">
                <label class="field-top__label">Medicamento</label>
                <input type="text" class="form-control" formControlName="medicamento" placeholder="">
              </div>

              <!-- Fecha inicio -->
              <div class="field-top mb-2">
                <label class="field-top__label">Fecha de inicio</label>
                <input type="date" class="form-control" formControlName="fecha_inicio">
              </div>

              <!-- Duración -->
              <div class="form-row">
                <div class="col-8 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Duración</label>
                    <input type="number" class="form-control" formControlName="duracion_valor" placeholder="">
                  </div>
                </div>

                <div class="col-4 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Unidad tiempo</label>
                    <select class="form-control" formControlName="duracion_unidad">
                      <option value="" disabled selected>Selecciona</option>
                      <option *ngFor="let u of duracionUnidades" [value]="u">{{ u }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Frecuencia -->
              <div class="form-row">
                <div class="col-4 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Cantidad</label>
                    <input type="number" class="form-control" formControlName="frecuencia_veces" placeholder="">
                  </div>
                </div>

                <div class="col-4 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Cada</label>
                    <input type="number" class="form-control" formControlName="frecuencia_cada" placeholder="">
                  </div>
                </div>

                <div class="col-4 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Unidad tiempo</label>
                    <select class="form-control" formControlName="frecuencia_unidad">
                      <option value="" disabled selected>Selecciona</option>
                      <option *ngFor="let u of frecuenciaUnidades" [value]="u">{{ u }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Dosis -->
              <div class="form-row">
                <div class="col-8 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Dosis</label>
                    <input type="number" class="form-control" formControlName="dosis_valor" placeholder="">
                  </div>
                </div>

                <div class="col-4 mb-2">
                  <div class="field-top">
                    <label class="field-top__label">Unidad de medida</label>
                    <select class="form-control" formControlName="dosis_unidad">
                      <option value="" disabled selected>Selecciona</option>
                      <option *ngFor="let u of dosisUnidades" [value]="u">{{ u }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Comentario -->
              <div class="field-top mb-2">
                <label class="field-top__label">Comentario (opcional)</label>
                <textarea class="form-control" rows="4" formControlName="comentario" placeholder=""></textarea>
              </div>

              <!-- Acciones -->
              <div class="text-right">
                <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarMedicamento()">
                  Cancelar
                </button>
                <button type="submit" class="btn btn-guardar px-4" [disabled]="medicamentosForm.invalid">
                  Guardar cambios
                </button>
              </div>

            </div>
          </form>
        </div>

        <button type="button" class="acc-collapse" (click)="toggle('medicamentos')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </section>

    <section class="acc-item" [class.open]="open.habitos">
      <header class="acc-header" (click)="toggle('habitos')">
        <div class="acc-left">
          <i class="fi fi-rr-meditation" style="display: flex;
      font-size: larger;"></i> <span>Hábitos y estilo de vida</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.habitos">expand_more</mat-icon>
        </div>
      </header>
      <div class="acc-body">
        <div class="text-center mb-2" *ngIf="!agregandoHabito && (mis_antecedentes?.habit?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarHabito()">
            <span class="plus">+</span> Agregar
          </button>
        </div>
        <ng-container *ngIf="!agregandoHabito">
          <div *ngFor="let item of (mis_antecedentes?.habit || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;">{{ item.hab_name | titlecase}}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'habitos')"
                style="display: flex; align-items: center; gap: 5px; cursor: pointer-content; justify-content: flex-end;">
                <i class="fi fi-rr-trash"></i>
              </div>
            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-clock-up-arrow"></i>
                <span>
                  {{ item.fre_name }}
                </span>
              </div>
              <div>{{ item.ben_fin_hab_comments }}</div>
            </div>

          </div>
        </ng-container>
        <div *ngIf="agregandoHabito || (mis_antecedentes?.habit?.length || 0) === 0">
          <form [formGroup]="habitosForm" (ngSubmit)="crearHabito()">
  <div class="form-group">

    <div class="field-top mb-2">
      <label class="field-top__label">Nombre</label>
      <select class="form-control" formControlName="id_habito">
        <option value="" selected>Selecciona</option>
        <option *ngFor="let zona of habitos_list" [value]="zona.hab_id" [disabled]="!zona.disponible">
          {{ zona.hab_name }}
        </option>
      </select>
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Frecuencia</label>
      <select class="form-control" formControlName="id_frecuencia">
        <option value="" selected>Selecciona</option>
        <option *ngFor="let zona of frecuency_list" [value]="zona.fre_id">
          {{ zona.fre_name }}
        </option>
      </select>
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Comentario</label>
      <textarea class="form-control" rows="4" formControlName="comentario" placeholder=""></textarea>
    </div>

    <div class="text-right">
      <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarHabito()">Cancelar</button>
      <button type="submit" class="btn btn-guardar px-4" [disabled]="habitosForm.invalid">Guardar cambios</button>
    </div>

  </div>
</form>

        </div>


        <button type="button" class="acc-collapse" (click)="toggle('habitos')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </section>

    <section class="acc-item" [class.open]="open.cirugias">
      <header class="acc-header" (click)="toggle('cirugias')">
        <div class="acc-left">
          <i class="fi fi-rr-scalpel" style="display: flex;
      font-size: larger;"></i> <span>Cirugias</span>
        </div>
        <div class="acc-right">
          <mat-icon class="chev" [class.rot]="open.cirugias">expand_more</mat-icon>
        </div>
      </header>
      <div class="acc-body">
        <div class="text-center mb-2" *ngIf="!agregandoCirugia && (mis_antecedentes?.surgery?.length || 0) > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarCirugia()">
            <span class="plus">+</span> Agregar
          </button>
        </div>
        <ng-container *ngIf="!agregandoCirugia">
          <div *ngFor="let item of (mis_antecedentes?.surgery || []); let i = index" class="card-item">
            <div class="row">
              <div class="col-8">
                <h6 class="mb-2" style=" white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;">{{ item.ben_fil_sur_procedure | titlecase}}</h6>
              </div>
              <div class="col-4 text-muted mb-2" (click)="abrirModalEliminar(i, item, 'cirugias')"
                style="display: flex; align-items: center; gap: 5px; cursor: pointer-content; justify-content: flex-end;">
                <i class="fi fi-rr-trash"></i>
              </div>
            </div>
            <div class="small text-muted">
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-calendar"></i>
                <span>Fecha cirugia: {{ item.ben_fil_sur_date_surgery | date:'dd/MM/yyyy' }} </span>
              </div>
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <i class="fi fi-rr-user"></i>
                <span>Médico: {{ item.ben_fil_sur_doctor }} </span>
              </div>
              <div class="mb-1"
                style="display: flex; gap: 5px; align-items: center; justify-content: flex-start; line-height: normal;">
                <span>Comentario: {{ item.ben_fil_sur_comments }}</span>
              </div>
            </div>

          </div>
        </ng-container>
        <div *ngIf="agregandoCirugia || (mis_antecedentes?.surgery?.length || 0) === 0">
          <form [formGroup]="cirugiaForm" (ngSubmit)="crearCirugia()">
  <div class="form-group">

    <div class="field-top mb-2">
      <label class="field-top__label">Nombre cirugía</label>
      <input type="text" class="form-control" formControlName="nombre_cirugia" placeholder="">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Fecha de cirugía</label>
      <input type="date" class="form-control" formControlName="fecha_cirugia">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Nombre médico</label>
      <input type="text" class="form-control" formControlName="nombre_medico" placeholder="">
    </div>

    <div class="field-top mb-2">
      <label class="field-top__label">Comentario</label>
      <textarea class="form-control" rows="4" formControlName="comentario" placeholder=""></textarea>
    </div>

    <div class="text-right">
      <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAgregarCirugia()">Cancelar</button>
      <button type="submit" class="btn btn-guardar px-4" [disabled]="cirugiaForm.invalid">Guardar cambios</button>
    </div>

  </div>
</form>

        </div>


        <button type="button" class="acc-collapse" (click)="toggle('habitos')" aria-label="Cerrar">
          <mat-icon>expand_less</mat-icon>
        </button>
      </div>
    </section>

  </ng-container>

</div>

<!-- Modal liviano para confirmación de eliminación -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmacionEliminar'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Está seguro que desea eliminar este antecedente?</h2>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()">
          <p class="m-0" style="font-weight: 600; line-height: inherit;">Cancelar</p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" (click)="eliminarAntecedente()">
          <p class="m-0" style="font-weight: 600; line-height: inherit;">Aceptar</p>
        </button>
      </div>
    </div>
  </div>
</div>